/** Brevity PWF web app — project (job) detail page. */
export const PWF_PROJECT_URL_BASE =
  'https://app.proworkflow.com/Brevity/?fuseaction=jobs&fusesubaction=jobdetails&Jobs_currentJobID='

export function pwfProjectUrl(projectId: string | number | null | undefined): string | null {
  if (projectId == null || projectId === '') return null
  const id = String(projectId).trim()
  if (!/^\d+$/.test(id)) return null
  return `${PWF_PROJECT_URL_BASE}${id}`
}
